var _g, _g2, _g3, _g4, _g5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEthereumIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M5.99829 7.22363L0 9.95163L5.99829 13.4954L11.9942 9.95163L5.99829 7.22363Z",
    fill: "#141332"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M0 9.95235L5.99829 13.4962V0L0 9.95235Z",
    fill: "#141332"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M5.99902 0V13.4962L11.995 9.95235L5.99902 0Z",
    fill: "#141332"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M0 11.0889L5.99829 19.5393V14.6327L0 11.0889Z",
    fill: "#141332"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M5.99902 14.6327V19.5393L11.9997 11.0889L5.99902 14.6327Z",
    fill: "#141332"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereumIcon);
export default __webpack_public_path__ + "static/media/ethereumIcon.dcff6ac5aebc7fa27fb42727760e96ad.svg";
export { ForwardRef as ReactComponent };